<template>
    <div class="access_parking_records">
        <!--    Diálogo Modal para Confirmación Eliminar Invitación        -->
        <v-dialog v-model="dialog_elimnar" max-width="290">
            <v-card>
                <v-card-title class="headline">
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>{{$t('msg_cancelar_invit')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="dialog_elimnar = false"
                    >
                        {{$t('No')}}
                    </v-btn>

                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="cancelar_invitacion"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- Modal for Invitation Details -->
        <v-dialog v-model="dialog_invitation_details" max-width="1000px" scrollable persistent>
            <v-card class="premium-card overflow-hidden">
                <v-toolbar dark color="primary">
                    <v-icon large class="mr-3">local_parking</v-icon>
                    <v-toolbar-title class="headline font-weight-bold">{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="white" flat icon @click="dialog_invitation_details = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pa-0" v-if="loading_invitation_details">
                    <v-layout justify-center align-center fill-height class="pa-5">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-layout>
                </v-card-text>

                <v-card-text class="pa-0" v-else-if="info_invitation && Object.keys(info_invitation).length > 0">
                    <v-container grid-list-md>
                        <!-- NUEVA ESTRUCTURA DE RESERVAS -->
                        <div v-if="info_invitation.isParkingReservation">
                            <v-layout row wrap>
                                <!-- Owner Company Section -->
                                <v-flex xs12 md6>
                                    <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                        <h3 class="title primary--text text-xs-center mb-4">Empresa Dueña</h3>
                                        
                                        <v-list class="transparent" dense>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">Empresa</v-list-tile-sub-title>
                                                    <v-list-tile-title class="font-weight-bold">{{ info_invitation.owner_company_name || '-' }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="blue-grey">business</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>

                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">Estado</v-list-tile-sub-title>
                                                    <v-list-tile-title>
                                                        <v-chip :color="info_invitation.status === 'active' ? 'green' : 'orange'" text-color="white" small>
                                                            {{ info_invitation.status === 'active' ? 'Activa' : 'Cancelada' }}
                                                        </v-chip>
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small :color="info_invitation.status === 'active' ? 'green' : 'orange'">{{ info_invitation.status === 'active' ? 'check_circle' : 'cancel' }}</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </v-list>
                                    </v-card>
                                </v-flex>

                                <!-- Beneficiary Company Section -->
                                <v-flex xs12 md6>
                                    <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                        <h3 class="title primary--text text-xs-center mb-4">Empresa Beneficiaria</h3>
                                        
                                        <v-list class="transparent" dense>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">Empresa</v-list-tile-sub-title>
                                                    <v-list-tile-title class="font-weight-bold">{{ info_invitation.beneficiary_company_name || '-' }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="blue-grey">business</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </v-list>
                                    </v-card>
                                </v-flex>
                            </v-layout>

                            <!-- Dates and Times Section -->
                            <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                <h3 class="title primary--text mb-3">Período de Reserva</h3>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 md3>
                                        <div>
                                            <v-list-tile-sub-title class="caption blue-grey--text">Fecha Inicio</v-list-tile-sub-title>
                                            <div class="font-weight-bold">{{ formatDateDDMMYYYY(info_invitation.start_date) }}</div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <div>
                                            <v-list-tile-sub-title class="caption blue-grey--text">Fecha Fin</v-list-tile-sub-title>
                                            <div class="font-weight-bold">{{ formatDateDDMMYYYY(info_invitation.end_date) }}</div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <div>
                                            <v-list-tile-sub-title class="caption blue-grey--text">Hora Inicio</v-list-tile-sub-title>
                                            <div class="font-weight-bold">{{ info_invitation.start_time || 'No especificada' }}</div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <div>
                                            <v-list-tile-sub-title class="caption blue-grey--text">Hora Fin</v-list-tile-sub-title>
                                            <div class="font-weight-bold">{{ info_invitation.end_time || 'No especificada' }}</div>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-card>

                            <!-- Notes Section -->
                            <v-card v-if="info_invitation.notes" flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                <h3 class="title primary--text mb-2">Notas</h3>
                                <v-list-tile-sub-title>{{ info_invitation.notes }}</v-list-tile-sub-title>
                            </v-card>

                            <!-- Reserved Spaces Section -->
                            <v-card flat class="blue-grey lighten-5 rounded-card pa-3">
                                <h3 class="title primary--text mb-3">Cajones Reservados</h3>
                                <v-layout row wrap v-if="info_invitation.reserved_spaces && info_invitation.reserved_spaces.length > 0">
                                    <v-flex v-for="space in info_invitation.reserved_spaces" :key="space.id" xs12 sm6 md4>
                                        <v-card flat class="pa-2" style="background-color: #f5f5f5; border-left: 4px solid #1976d2;">
                                            <div class="font-weight-bold primary--text">{{ space.space_number }}</div>
                                            <v-list-tile-sub-title class="caption">{{ space.section_name || '-' }}</v-list-tile-sub-title>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-else justify-center align-center class="pa-3">
                                    <span class="caption grey--text">No hay cajones reservados</span>
                                </v-layout>
                            </v-card>
                        </div>

                        <!-- ESTRUCTURA ANTIGUA DE INVITACIONES -->
                        <div v-else>
                            <v-layout row wrap>
                                <!-- Guest Section -->
                                <v-flex xs12 md6>
                                    <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                        <div class="d-flex align-center justify-center mb-3">
                                            <v-img 
                                                :src="info_invitation.guest_avatar || 'https://via.placeholder.com/180'"
                                                max-width="180"
                                                max-height="180"
                                                contain
                                                class="elevation-4 mx-auto mb-3"
                                                style="border-radius: 8px;"
                                            ></v-img>
                                        </div>
                                        <h3 class="title primary--text text-xs-center mb-4">{{$t('info_invitado')}}</h3>
                                        
                                        <v-list class="transparent" dense>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">{{$t('Visitante')}}</v-list-tile-sub-title>
                                                    <v-list-tile-title class="font-weight-bold">{{ info_invitation.guest_first_name }} {{ info_invitation.guest_last_name }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="blue-grey">person</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>

                                            <v-list-tile v-if="info_invitation.guest_phone">
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">{{$t('celular')}}</v-list-tile-sub-title>
                                                    <v-list-tile-title>{{ info_invitation.guest_phone }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="blue-grey">phone_iphone</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>

                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">{{$t('Asunto')}}</v-list-tile-sub-title>
                                                    <v-list-tile-title>{{ info_invitation.subject }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="blue-grey">notes</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>

                                            <v-list-tile v-if="info_invitation.expiration && info_invitation.invitation_date">
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">{{$t('validity')}}</v-list-tile-sub-title>
                                                    <v-list-tile-title>{{ info_invitation.invitation_date && info_invitation.invitation_date.replace(/-/g, '/') }} - {{ info_invitation.expiration && info_invitation.expiration.replace(/-/g, '/') }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="primary">event</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>

                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">Horario</v-list-tile-sub-title>
                                                    <v-list-tile-title>{{ getParkingTimeRange(info_invitation) || 'Todo el dia' }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="primary">schedule</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                            
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">{{$t('Espacios')}}</v-list-tile-sub-title>
                                                    <v-list-tile-title>{{ info_invitation.space_number || '-' }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="blue-grey">local_parking</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </v-list>
                                    </v-card>
                                </v-flex>

                                <!-- Host Section -->
                                <v-flex xs12 md6>
                                    <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                        <div class="d-flex align-center justify-center mb-3">
                                            <v-img 
                                                :src="info_invitation.host_avatar || 'https://via.placeholder.com/180'"
                                                max-width="180"
                                                max-height="180"
                                                contain
                                                class="elevation-4 mx-auto mb-3"
                                                style="border-radius: 8px;"
                                            ></v-img>
                                        </div>
                                        <h3 class="title primary--text text-xs-center mb-4">{{$t('info_anfitrion')}}</h3>
                                        
                                        <v-list class="transparent" dense>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">{{$t('Anfitrion')}}</v-list-tile-sub-title>
                                                    <v-list-tile-title class="font-weight-bold">{{ info_invitation.host_first_name }} {{ info_invitation.host_last_name }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="blue-grey">business_center</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>

                                            <v-list-tile v-if="info_invitation.host_phone">
                                                <v-list-tile-content>
                                                    <v-list-tile-sub-title class="caption blue-grey--text">{{$t('celular')}}</v-list-tile-sub-title>
                                                    <v-list-tile-title>{{ info_invitation.host_phone }}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon small color="blue-grey">phone_iphone</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </v-list>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-container>
                </v-card-text>
                <v-card-text v-else class="pa-0">
                    <v-layout justify-center align-center fill-height class="pa-5">
                        <span class="subheading grey--text">{{$t('no_data_available')}}</span>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4 bg-muted">
                    <v-layout align-center justify-center row wrap>
                        <v-flex xs12 class="text-xs-center d-flex justify-center flex-wrap">
                            <v-btn large depressed class="rounded-btn mx-2 my-1" color="primary" @click="dialog_invitation_details = false">
                                <v-icon left>close</v-icon>
                                {{ $t('cerrar')}}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialog_inicio" persistent max-width="400px">
            <v-form @submit.prevent="set_caseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="nombre"
                                item-value="id"
                                :label="$t('Casetas')"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('aceptar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores   -->
        <v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
<!--                    <h3 class="text-xs-center">{{errores_guard}}</h3>-->
                    <div class="text-xs-center" v-html="errores_guard" />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete(dataAccessNoCode.nombre, dataAccessNoCode.host, dataAccessNoCode.f_acceso, dataAccessNoCode.company_logo)"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', band_gafete = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Mensaje   -->
        <v-dialog v-model="bandConfirm"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title class="warning display-1 text--primary justify-center"
                      primary-title>
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    <div class="text-xs-center">
                      {{$t('at_least_one_data')}}
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="bandConfirm = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogTransport" persistent max-width="400px">
              <v-card class="justify-center">
                  <v-toolbar dark color="primary">
                      <v-toolbar-title>
                          {{bandTransportUpdate === true? $t('add_carrier_data') : $t('carrier_data')}}
                      </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="text-xs-center">
                      <v-radio-group
                          row
                          :disabled="!bandTransportUpdate"
                          v-model="typeService"
                          prepend-icon="trolley"
                          name="typeService"
                          :mandatory="false"
                          :error-messages="errores.typeService"
                      >
                        <v-radio :label="$t('load')" :value="true"></v-radio>
                        <v-radio :label="$t('download')" :value="false"></v-radio>
                      </v-radio-group>
                      <v-text-field
                          v-model="case_plates"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="inventory"
                          name="case_plates"
                          :label="$t('case_plates')"
                          :error-messages="errores.case_plates"
                      >
                      </v-text-field>
                      <v-text-field
                          v-model="container_platform_plates"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="local_shipping"
                          name="container_platform_plates"
                          :label="$t('container_platform_plates')"
                          :error-messages="errores.container_platform_plates"
                      >
                      </v-text-field>
                      <v-text-field
                          v-model="transport_line"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="rv_hookup"
                          name="transport_line"
                          :label="$t('transport_line')"
                          :error-messages="errores.transport_line"
                      >
                      </v-text-field>
                      <v-text-field
                          v-model="supplier_customer_name"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="business"
                          name="supplier_customer_name"
                          :label="$t('supplier_customer_name')"
                          :error-messages="errores.supplier_customer_name"
                      >
                      </v-text-field>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn
                              color="primary"
                              @click="dialogTransport = false"
                      >{{ $t('cancelar') }}
                      </v-btn>
                    <v-spacer/>
                    <v-btn
                        v-show="bandTransportUpdate === true"
                        color="primary"
                        @click="addAccessCarrierData"
                        :loading="loading"
                    >{{$t('guardar')}}
                    </v-btn>
                    <v-btn
                        v-show="bandTransportUpdate === false"
                        color="primary"
                        @click="dialogTransport = false"
                    >{{$t('aceptar')}}
                    </v-btn>
                  </v-card-actions>
              </v-card>
        </v-dialog>
        <v-dialog v-model="dialogShowPlacas" persistent max-width="400px">
              <v-card class="justify-center">
                  <v-toolbar dark color="primary">
                      <v-toolbar-title>
                          {{$t('placas')}}
                      </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="text-xs-center">
                    <v-img
                        :src="imagenPlacas"
                        position="center center"
                        class="grey lighten-2"
                    ></v-img>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn
                              color="primary"
                              @click="dialogShowPlacas = false, imagenPlacas = ''"
                      >{{ $t('cerrar') }}
                      </v-btn>
                  </v-card-actions>
              </v-card>
        </v-dialog>
        <!-- Dialog for Parking Access Details -->
        <v-dialog v-model="dialog_access_details" max-width="900px" scrollable persistent>
            <v-card class="premium-card overflow-hidden">
                <v-toolbar dark color="primary">
                    <v-icon large class="mr-3">info</v-icon>
                    <v-toolbar-title class="headline font-weight-bold">Detalles de Acceso</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="white" flat icon @click="dialog_access_details = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pa-0" v-if="loading_access_details">
                    <v-layout justify-center align-center fill-height class="pa-5">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-layout>
                </v-card-text>

                <v-card-text class="pa-0" v-else-if="access_details_data && Object.keys(access_details_data).length > 0">
                    <v-container grid-list-md>
                        <v-layout row wrap>
                            <!-- Access Information Section -->
                            <v-flex xs12 md6>
                                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                    <h3 class="title primary--text text-xs-center mb-4">Información de Acceso</h3>
                                    <v-list class="transparent" dense>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Visitante</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{ access_details_data.guest_name || '-' }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">person</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Cajon Asignado</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{ access_details_data.space_number || '-' }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">local_parking</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">QR Code</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.qr_code || '-' }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">qr_code</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Asunto</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.invitation_subject || '-' }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">notes</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Hora Acceso</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.access_time || '-' }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">schedule</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Hora Salida</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.exit_time || 'Pendiente' }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">exit_to_app</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Registrado por</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.registered_by_name || '-' }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">person_outline</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Provider Information Section -->
                            <v-flex xs12 md6>
                                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                    <h3 class="title primary--text text-xs-center mb-4">Datos del Proveedor</h3>
                                    <v-list class="transparent" dense>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Nombre</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{ access_details_data.provider_first_name }} {{ access_details_data.provider_last_name || '-' }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">person</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile v-if="access_details_data.provider_phone">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Teléfono</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.provider_phone }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">phone_iphone</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile v-if="access_details_data.provider_email">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Email</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.provider_email }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">email</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile v-if="access_details_data.provider_ine">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">INE</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.provider_ine }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">card_membership</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile v-if="access_details_data.provider_plates">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Placas</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.provider_plates }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">directions_car</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-list-tile v-if="access_details_data.provider_unit_specs">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Especificaciones Unidad</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ access_details_data.provider_unit_specs }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">local_shipping</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-text v-else class="pa-0">
                    <v-layout justify-center align-center fill-height class="pa-5">
                        <span class="subheading grey--text">No hay datos disponibles</span>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4 bg-muted">
                    <v-layout align-center justify-center row wrap>
                        <v-flex xs12 class="text-xs-center d-flex justify-center flex-wrap">
                            <v-btn large depressed class="rounded-btn mx-2 my-1" color="primary" @click="dialog_access_details = false">
                                <v-icon left>close</v-icon>
                                Cerrar
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-container class="my-1">
            <v-layout calign-center>
                <v-dialog scrollable v-model="dialog_accesos_no_code_express" max-width="600">
                    <v-card color="blue-grey lighten-4"  class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Detalles</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_accesos_no_code_express = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div class="text-xs-center">
                                <v-layout justify-center class="text-xs-center" row wrap>
                                    <v-flex xs12>
                                        <v-layout align-center justify-center row wrap>
                                            <v-flex class="text-xs-center">
                                                <v-img
                                                        :src="data_accesos_no_code_express.url_foto"
                                                        position="center center"
                                                        class="grey lighten-2"
                                                ></v-img>
                                                <table id="datas">
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Visitante')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.nombre}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Espacios')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.areaName}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Notas')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ (data_accesos_no_code_express.notas === '' || data_accesos_no_code_express.notas === null) ? "Sin Notas" : data_accesos_no_code_express.notas}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_acceso')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.f_acceso}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_salida')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.f_salida ? data_accesos_no_code_express.f_salida : "Salida no registrada" }}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-dialog scrollable persistent v-model="dialog_accesos_without_code" max-width="1000">
                    <v-card :loading="loadingCountInAccessNoCode" v-if="entrada" :color="dataAccessNoCode.authorized ? 'blue-grey lighten-4' : 'yellow lighten-2'" class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_accesos_without_code = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div class="text-xs-center">
                                <v-layout justify-center class="text-xs-center" row wrap>
                                    <v-flex xs12>
                                        <h2>{{$t('info_invitado')}}</h2>
                                        <br>
                                        <v-layout align-center justify-center row wrap>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                              <v-img
                                                  :src="data_accesos_without_code.url_foto"
                                                  position="center center"
                                                  class="grey lighten-2"
                                              ></v-img>
                                            </v-flex>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                                <table id="datas">
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Visitante')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.nombre}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Empresa')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.empresa}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Espacios')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.areaName}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Notas')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.notas}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_acceso')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_acceso}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_salida')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_salida ? data_accesos_without_code.f_salida : "Salida no registrada" }}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Anfitrion')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{data_accesos_without_code.host}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                          </v-card-text>
                        <v-card-actions class="justify-center">
                          <v-layout align-center justify-center row wrap>
                            <v-flex v-if="!dataAccessNoCode.authorized" xs12 class="text-xs-center">
                              <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_authorized}}/2</h3>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center">
                              <v-btn
                                  large
                                  color="error"
                                  @click="dialog_accesos_without_code = false"
                              >{{ $t('cerrar')}}
                              </v-btn>
                              <v-btn
                                  v-if="dataAccessNoCode.authorized"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode === 0"
                                  large
                                  color="primary"
                                  :loading="loading"
                                  @click="notificar_anfitrion_acceso_sin_codigo(dataAccessNoCode.id)"
                              >
                                Notificar al anfitrión <br> autorizar acceso
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode > 0"
                                  large
                                  color="primary"
                              >
                                Disponible en : {{countDownAuthorizedAccessNoCode}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized === 0"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0"
                                  large
                                  :loading="loadingCountInAccessNoCode"
                                  color="primary"
                                  @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                              >
                                <v-icon>refresh</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                    </v-card>
                    <v-card :loading="loadingCountInAccessNoCode" v-if="salida" :color="dataAccessNoCode.pase_salida ? 'blue-grey lighten-4' : 'red lighten-2'" class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_accesos_without_code = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div class="text-xs-center">
                                <v-layout justify-center class="text-xs-center" row wrap>
                                    <v-flex xs12>
                                        <h2>{{$t('info_invitado')}}</h2>
                                        <br>
                                        <v-layout align-center justify-center row wrap>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                              <v-img
                                                  :src="data_accesos_without_code.url_foto"
                                                  position="center center"
                                                  class="grey lighten-2"
                                              ></v-img>
                                            </v-flex>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                                <table id="datas">
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Visitante')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.nombre}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Empresa')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.empresa}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Espacios')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.areaName}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Notas')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.notas}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_acceso')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_acceso}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_salida')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_salida ? data_accesos_without_code.f_salida : "Salida no registrada" }}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Anfitrion')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{data_accesos_without_code.host}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                          <v-layout align-center justify-center row wrap>
                            <v-flex v-if="!dataAccessNoCode.pase_salida" xs12 class="text-xs-center">
                              <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_pase_salida}}/2</h3>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center">
                              <v-btn
                                  large
                                  color="error"
                                  @click="dialog_accesos_without_code = false"
                              >{{ $t('cerrar')}}
                              </v-btn>
                              <v-btn
                                  v-if="dataAccessNoCode.pase_salida"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_check_out_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('registrar_salida')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0 && countDownSign === 0"
                                  large
                                  color="primary"
                                  :loading="loading"
                                  @click="notificar_anfitrion_firmar(dataAccessNoCode.id)"
                              >
                                Notificar al anfitrión <br> firmar pase de salida
                              </v-btn>
                              <v-btn
                                      v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0 && countDownSign > 0"
                                      large
                                      color="primary"
                              >
                                  Disponible en : {{countDownSign}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida === 0"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_check_out_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('registrar_salida')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0"
                                  large
                                  :loading="loadingCountInAccessNoCode"
                                  color="primary"
                                  @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                              >
                                <v-icon>refresh</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-flex>
                    <v-card class="elevation-5">
                        <v-card-text>
                            <h3>{{$t('mostrando_historial_dia')}}</h3>
                            <v-form
                                    @submit.prevent="submit()">
                                <v-layout class="align-center " row wrap>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedInitialDateFormatted"
                                                        prepend-icon="event"
                                                        name="date"
                                                        :label="$t('Fecha_ini')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date"
                                                    @input="calendario = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedFinalDateFormatted"
                                                        prepend-icon="event"
                                                        name="date2"
                                                        :label="$t('Fecha_fin')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date2"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date2"
                                                    @input="calendario2 = false, submit()">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn
                                                color="primary"
                                                type="submit"
                                                large
                                        >{{ $t('Filtrar') }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-card class="my-2" v-show="getProfile.enable_parking">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('access_history_parking')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-tabs
                            grow
                            fixed-tabs
                            color="transparent"
                            slider-color="primary">
                        <v-tab>
                            <v-icon left>send</v-icon>
                            {{$t('enviados')}}
                        </v-tab>
                        <v-tab>
                            <v-icon left>compare_arrows</v-icon>
                            {{$t('Accesos')}}
                        </v-tab>
                        
                        <v-tab-item>
                            <v-data-table
                                    :headers="headersParkingSent"
                                    :loading="loading_parking_reservations_sent"
                                    :items="mappedParkingInvitationsSent"
                                    item-key="uniqueId"
                                    :rows-per-page-text="$t('filas_por_pagina')"
                                    :rows-per-page-items="[
                                                        {text: '5', value: 5},
                                                        {text: '10', value: 10},
                                                        {text: '25', value: 25},
                                                        {text: this.$t('todos'), value: -1}]"
                                    class="elevation-1"
                                    :no-data-text="$t('no_registros_invit')"
                            >
                                <template v-slot:items="props">
                                    <td align="center" class="justify-center layout px-0">
                                        <v-icon
                                            v-if="!props.item.isParkingPendingReferred"
                                            medium
                                            @click="fetch_invitation_details_for_modal(props.item)"
                                        >
                                            search
                                        </v-icon>
                                    </td>
                                    <td>
                                        <v-chip :color="props.item.chipColor" text-color="white" small>
                                            {{ props.item.chipText }}
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-chip
                                            label
                                            :color="props.item.canceled === true ? 'error' : 'success'"
                                            dark
                                        >
                                          <v-icon left v-if="props.item.canceled">
                                            event_busy
                                          </v-icon>
                                          <v-icon left v-else>
                                            event
                                          </v-icon>
                                          {{props.item.canceled === true ? $t('canceled') : $t('current') }}
                                        </v-chip>
                                    </td>
                                    <td>
                                        {{ formatDateDDMMYYYY(props.item.fechaEnvio) }}
                                        {{ formatHourMinute(props.item.fechaEnvio) }}
                                    </td>
                                    <td>
                                        {{ formatDateDDMMYYYY(props.item.normalizedDate) }}
                                        {{ props.item.normalizedTime }}
                                    </td>
                                    <td>{{ props.item.empresa || '-' }}</td>
                                    <td>
                                        {{ props.item.isParkingPendingReferred ? '-' : props.item.normalizedGuest }}
                                    </td>
                                    <td>{{ props.item.space_number || '-' }}</td>
                                </template>
                                <template v-slot:pageText="props">
                                    {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                </template>
                            </v-data-table>
                        </v-tab-item>
                        
                        <v-tab-item>
                            <v-layout class="my-4" align-center justify-center fill-height>
                                <v-flex>
                                    <v-layout row wrap align-center class="mb-3">
                                        <v-flex xs12 sm6>
                                            <v-card-title>
                                              <v-text-field
                                                  v-model="searchDataParking"
                                                  append-icon="search"
                                                  :label="$t('Buscar')"
                                                  single-line
                                                  hide-details
                                              ></v-text-field>
                                            </v-card-title>
                                        </v-flex>
                                        <v-flex xs12 sm6 class="text-xs-right pr-3">
                                            <v-btn 
                                                color="primary" 
                                                small
                                                @click="exportPdfAccessParking"
                                                :disabled="!dataAccessParking || dataAccessParking.length === 0"
                                                class="mr-2"
                                            >
                                                <v-icon left small>picture_as_pdf</v-icon>
                                                {{$t('exportar_pdf') || 'Exportar PDF'}}
                                            </v-btn>
                                            <v-btn 
                                                color="success" 
                                                small
                                                @click="exportExcelAccessParking"
                                                :disabled="!dataAccessParking || dataAccessParking.length === 0"
                                            >
                                                <v-icon left small>table_chart</v-icon>
                                                {{$t('exportar_excel') || 'Exportar Excel'}}
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-data-table
                                            :headers="headersParkingAccess"
                                            :loading="loading_data_parking"
                                            :items="dataAccessParking"
                                            :search="searchDataParking"
                                            :rows-per-page-text="$t('filas_por_pagina')"
                                            :rows-per-page-items="[
                                                {text: '10', value: 10},
                                                {text: '20', value: 20},
                                                {text: '50', value: 50},
                                                {text: this.$t('todos'), value: -1}
                                            ]"
                                            class="elevation-1"
                                            :no-data-text="$t('no_registros_accesos')"
                                    >
                                        <template v-slot:no-results>
                                            <v-alert :value="true" color="error" class="white--text" icon="warning">
                                                {{$t('ningun_resultado_1')}} "{{ searchDataParking }}" {{$t('ningun_resultado_2')}}
                                            </v-alert>
                                        </template>
                                        <template v-slot:items="props">                                    
                                            <td>{{ props.item.guest_name }}</td>
                                            <td>{{ props.item.guest_company || props.item.company_name || '-' }}</td>
                                            <td>{{ props.item.space_number }}</td>
                                            <td><v-chip :color="props.item.exit_time ? 'success' : 'gray'">{{ props.item.exit_time ? $t('completado') : $t('adentro') }}</v-chip></td>
                                            <td>{{ props.item.access_time === null ? $t('pendiente')  : props.item.access_time }}</td>
                                            <td>{{ props.item.exit_time === null ? $t('pendiente')  : props.item.exit_time }}</td>
                                            <td>{{ props.item.registered_by_name}}</td>
                                            <td class="text-xs-center">
                                                <v-btn icon color="primary" @click="openAccessDetails(props.item)" title="Ver detalles">
                                                    <v-icon>search</v-icon>
                                                </v-btn>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-tab-item>

                    </v-tabs>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import {mapState} from 'vuex'
    import jsPDF from 'jspdf'
    import 'jspdf-autotable'
    import { mapGetters } from 'vuex'

    export default {
        name: "access_parking_records",
        data: () => ({
            alerta: false,
            calendario: false,
            calendario2: false,
            fecha_actual: '',
            date: '',
            date2: '',
            errores: [],
            search: '',
            searchDataParking: '',
            headers4: [],
            headers5: [],
            invitaciones:[],
            accesos_without_code: [],
            accesos_no_code_express: [],
            loading_data_invitaciones: false,
            loading_data_accesos_without_code: false,
            loading_data_accesos_no_code_express: false,
            loading_data_parking: false,
            yyyy: '',
            mm: '',
            dd: '',
            yyyy2: '',
            mm2: '',
            dd2: '',
            dialog_accesos_without_code: false,
            dialog_accesos_no_code_express: false,
            headersAccess: [],
            loading_data_accesos: false,
            accesos: [],
            headersAccessExcel: [],
            headersAccessNoCodeExcel: [],
            headersAccessNoCodeExpressExcel: [],
            data_accesos_without_code: [],
            data_accesos_no_code_express: [],
            band: false,
            search3: '',
            img: '',
            camera: null,
            deviceId: null,
            devices: [],
            dialogPlacas: false,
            loading: false,
            idAccess: '',
            idAccessNoCode: '',
            dialogShowPlacas: false,
            imagenPlacas: '',
            countDownAuthorized: 0,
            countDownPass: 0,
            dialog_errores: false,
            errores_guard: '',
            head_color: '',
            band_gafete: false,
            loading_gafete: false,
            salida: false,
            entrada: false,
            loadingCountInAccessNoCode: false,
            dataAccessNoCode: {},
            countDownAuthorizedAccessNoCode: 0,
            dialog_inicio: false,
            casetas: [],
            access: [],
            loading_data_access2: false,
            headersAccess2: [],
            headersParkingAccess: [],
            countDownSign: 0,
            caseta: 0,
            typeService: null,
            case_plates: '',
            container_platform_plates: '',
            transport_line: '',
            supplier_customer_name: '',
            bandTransportUpdate: false,
            bandConfirm: false,
            dialogTransport: false,
            accessQRCode: false,
            accessContractor: false,
            dataAccessParking: [],
            dialog_access_details: false,
            loading_access_details: false,
            access_details_data: {},
            id_empresa: '',
            loading_parking_sent: false,
            loading_parking_reservations_sent: false,
            parking_invitations_sent: {invitations: [], pending_referred: []},
            parking_reservations_sent: [],
            dialog_elimnar: false,
            id_invitacion_eliminar: '',
            dialog_invitation_details: false,
            loading_invitation_details: false,
            info_invitation: {},
            selected_invitation: {},
            headersParkingSent: [],
        }),
        created: function(){
            this.get_extra_data()
            this.fecha_actual = this.get_current_date()
            this.date = this.fecha_actual
            this.date2 = this.fecha_actual
            this.split_date(this.date, this.date2)
            // this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            // this.get_access_parking_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            // this.get_access_no_code_express_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.get_parking_reservations_sent(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
        },
        beforeUpdate() {
            this.headersParkingAccess = [
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_name'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_company'
                },
                {
                    text: this.$t('assigned_parking_space'),
                    align: 'left',
                    sortable: true,
                    value: 'space_number'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'access_type'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'access_time'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'exit_time'
                },
                {
                    text: this.$t('Vigilante'),
                    align: 'left',
                    sortable: true,
                    value: 'registered_by_name'
                },
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'actions'
                },
            ]
            this.headersParkingSent = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    value: 'name',
                    sortable: false
                },
                {
                    text: this.$t('Tipo'),
                    align: 'left',
                    sortable: true,
                    value: 'tipo'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'canceled'
                },
                {
                    text: this.$t('creacion'),
                    align: 'left',
                    sortable: true,
                    value: 'fechaEnvio'
                },
                {
                    text: this.$t('Fecha'),
                    align: 'left',
                    sortable: true,
                    value: 'llegada'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'visitante'
                },
                {
                    text: this.$t('espacios'),
                    align: 'left',
                    sortable: true,
                    value: 'espacios'
                }
            ]
            this.headersAccess2 = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('type_of_access'),
                    align: 'left',
                    sortable: true,
                    value: 'access_qr_code'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_full_name'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'company_name'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: this.$t('hora_llegada'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_arrival'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkin'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkout'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'host_full_name'
                }
            ],
            this.headersAccess = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'invitado'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa'
                },
                {
                    text: this.$t('temperature'),
                    align: 'left',
                    sortable: true,
                    value: 'temperature'
                },
                {
                    text: this.$t('estado'),
                    align: 'left',
                    sortable: true,
                    value: 'estado'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_salida'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'id_invitacion'
                }
            ],
            this.headersAccessExcel = [
                {
                    label: this.$t('type_of_access'),
                    field: 'access_qr_code',
                    dataFormat: this.typeAccessFormat
                },
                {
                    label: this.$t('Visitante'),
                    field: 'guest_full_name'
                },
                {
                    label: this.$t('Empresa'),
                    field: 'company_name',
                },
                {
                    label: this.$t('estado'),
                    field: 'status',
                    dataFormat: this.estadoFormat
                },
                {
                    label: this.$t('hora_llegada'),
                    field: 'datetime_arrival'
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'datetime_checkin'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'datetime_checkout'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'host_full_name'
                }
            ],
            this.headers4 = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'acciones'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'estado'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'f_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'f_salida'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'nombree'
                }
            ],
            this.headers5 = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'details'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'f_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'f_salida'
                }
            ],
            this.headersAccessNoCodeExcel = [
                {
                    label: this.$t('Visitante'),
                    field: 'nombre'
                },
                {
                    label: this.$t('Empresa'),
                    field: 'empresa',
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'f_acceso'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'f_salida'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'hostFirstName'
                }
            ]
            this.headersAccessNoCodeExpressExcel = [
                {
                    label: this.$t('Visitante'),
                    field: 'nombre'
                },
                {
                    label: this.$t('Area'),
                    field: 'areaName',
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'f_acceso'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'f_salida'
                },
                {
                    label: this.$t('Notas'),
                    field: 'notas'
                }
            ]
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile']),
            mappedParkingInvitationsSent() {
                let mapped = [];
                
                // Process parking_reservations_sent (new API)
                if (this.parking_reservations_sent && Array.isArray(this.parking_reservations_sent)) {
                    this.parking_reservations_sent.forEach(item => {
                        const dateRange = item.start_date === item.end_date 
                            ? this.formatDateDDMMYYYY(item.start_date)
                            : `${this.formatDateDDMMYYYY(item.start_date)} - ${this.formatDateDDMMYYYY(item.end_date)}`;
                        
                        const timeRange = item.start_time && item.end_time
                            ? `${item.start_time} - ${item.end_time}`
                            : 'Todo el día';
                        
                        mapped.push({
                            ...item,
                            uniqueId: 'uid_' + mapped.length,
                            chipColor: item.status === 'active' ? 'green' : 'orange',
                            chipText: 'Reserva Estacionamiento',
                            isShipment: false,
                            normalizedDate: item.start_date,
                            normalizedTime: timeRange,
                            empresa: item.beneficiary_company_name || '-',
                            normalizedHost: item.beneficiary_company_name || '-',
                            normalizedGuest: item.beneficiary_company_name || '-',
                            normalizedArea: item.reserved_spaces && item.reserved_spaces.length > 0 
                                ? item.reserved_spaces.map(s => s.space_number).join(', ')
                                : '-',
                            normalizedSubject: item.notes || '-',
                            canceled: item.status === 'canceled',
                            confirmed: item.status === 'active',
                            automovil: false,
                            isParkingData: true,
                            isParkingReservation: true,
                            dateRange: dateRange,
                            spacesCount: item.reserved_spaces ? item.reserved_spaces.length : 0
                        });
                    });
                }
                
                // Process parking_invitations_sent (old API - DEPRECATED)
                if (this.parking_invitations_sent) {
                    const processParkingSentArray = (arr, isPending) => {
                        if (Array.isArray(arr)) {
                            arr.forEach(item => {
                                mapped.push({
                                    ...item,
                                    uniqueId: 'uid_' + mapped.length,
                                    chipColor: isPending ? 'grey' : 'green',
                                    chipText: isPending ? 'Estacionamiento (Pendiente)' : 'Estacionamiento',
                                    isShipment: false,
                                    fechaEnvio: item.created_at || '-',
                                    normalizedDate: item.invitation_date,
                                    normalizedTime: this.getParkingTimeRange(item),
                                    normalizedHost: item.company_name || '',
                                    normalizedGuest: isPending ? (item.referred_email || item.referred_phone || '') : `${item.guest_first_name || ''} ${item.guest_last_name || ''}`.trim(),
                                    normalizedArea: '-',
                                    normalizedSubject: item.subject,
                                    isParkingData: true,
                                    isParkingPendingReferred: isPending,
                                });
                            });
                        }
                    };

                    if (Array.isArray(this.parking_invitations_sent)) {
                        processParkingSentArray(this.parking_invitations_sent, false);
                    } else {
                        processParkingSentArray(this.parking_invitations_sent.invitations, false);
                        processParkingSentArray(this.parking_invitations_sent.pending_referred, true);
                    }
                }
                return mapped;
            },
            computedInitialDateFormatted () {
                return this.formatDate(this.date)
            },
            computedFinalDateFormatted () {
                return this.formatDate(this.date2)
            },
            device () {
                return this.devices.find(n => n.deviceId === this.deviceId)
            }
        },
        watch: {
            camera: function(id) {
                this.deviceId = id
            },
            devices () {
                // Once we have a list select the first one
                const [first, ...tail] = this.devices
                if (first) {
                    this.camera = first.deviceId
                    this.deviceId = first.deviceId
                }else {
                    this.camera = tail.deviceId
                    this.deviceId = tail.deviceId
                }
            }
        },
        methods:{
                        normalizeApiTime(timeStr) {
                            if (!timeStr || typeof timeStr !== 'string') return ''
                            return timeStr.split(':').slice(0, 2).join(':')
                        },
                        getParkingTimeRange(item) {
                            const startTime = this.normalizeApiTime(item && item.start_time)
                            const endTime = this.normalizeApiTime(item && item.end_time)
                            if (startTime && endTime) return `${startTime} - ${endTime}`
                            return startTime || endTime || ''
                        },
            formatHourMinute(dateTime) {
            if (!dateTime) return '';
            let timePart = '';
            if (dateTime.includes('T')) {
                timePart = dateTime.split('T')[1];
            } else if (dateTime.includes(' ')) {
                timePart = dateTime.split(' ')[1];
            }
            if (timePart) {
                const [hh, mm] = timePart.split(':');
                return hh && mm ? ` ${hh}:${mm}` : '';
                                                    }
            return '';
            },                                         
            get_extra_data (){
                this.loading_data_parking = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data.id_company
                        this.get_access_parking_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_access_parking_by_date () {
                this.loading_data_parking = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/invitations/history/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        start_date: this.yyyy + '-' + this.mm + '-' + this.dd,
                        end_date: this.yyyy2 + '-' + this.mm2 + '-' + this.dd2,
                        empresa_id: this.id_empresa
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading_data_parking = false
                        console.log(response.data)
                        this.dataAccessParking = response.data
                    })
                    .catch(error => {
                        this.loading_data_parking = false
                        console.log(error)
                    })
            },
            cleanTransportFields () {
              this.typeService = null
              this.case_plates = null
              this.container_platform_plates = null
              this.transport_line = null
              this.supplier_customer_name = null
            },
            fillTransportFields (item) {
              this.typeService = item.download
              this.case_plates = item.case_plates
              this.container_platform_plates = item.container_platform_plates
              this.transport_line = item.transport_line
              this.supplier_customer_name = item.supplier_customer_name
            },
            exportPdfAccessUnion () {
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var adentro = this.$t('adentro')
                var pending_authorization = this.$t('pending_authorization')
                var completado = this.$t('completado')
                var waiting_room = this.$t('waiting_room')
                var no_firmado_completado = this.$t('no_firmado') + '/' + this.$t('completado')
                var denegado = this.$t('deny')
                var headerAccessNoCode = this.$t('headerAccess')
                var pendiente = this.$t('pendiente')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var con_codigo = this.$t('acceso_con_codigo')
                var sin_codigo = this.$t('acceso_sin_codigo')
                var total = 'Total: ' + this.access.length.toString()
                var columns = [{
                    access_qr_code: this.$t('type_of_access'),
                    guest_full_name: this.$t('Visitante'),
                    company_name: this.$t('Empresa'),
                    status: this.$t('estado'),
                    datetime_arrival: this.$t('hora_llegada'),
                    datetime_checkin: this.$t('hora_acceso'),
                    datetime_checkout: this.$t('hora_salida'),
                    host_full_name: this.$t('Anfitrion'),
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.access,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.row.section === 'body') {
                          if (data.column.index === 0) {
                            if (data.cell.text.toString() === 'true') {
                              data.cell.text = con_codigo
                            } else {
                              data.cell.text = sin_codigo
                            }
                          }
                          if (data.column.index === 6) {
                            if (data.cell.text.toString() === '') {
                              data.cell.text = pendiente
                            }
                          }
                          if (data.column.index === 5) {
                            if (data.cell.text.toString() === '') {
                              data.cell.text = pendiente
                            }
                          }
                          if (data.column.index === 3) {
                            if (data.cell.text.toString() === '0') {
                              data.cell.text = pending_authorization
                            }
                            if (data.cell.text.toString() === '1') {
                              data.cell.text = adentro
                            }
                            if (data.cell.text.toString() === '2') {
                              data.cell.text = completado
                            }
                            if (data.cell.text.toString() === '3') {
                              data.cell.text = no_firmado_completado
                            }
                            if (data.cell.text.toString() === '4') {
                              data.cell.text = denegado
                            }
                            if (data.cell.text.toString() === '5') {
                              data.cell.text = waiting_room
                            }
                          }
                        }
                    },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('access' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            countDownTimerAccessNoCode(id) {
              if(this.countDownAuthorizedAccessNoCode > 0) {
                setTimeout(() => {
                  this.countDownAuthorizedAccessNoCode -= 1
                  this.countDownTimerAccessNoCode(id)
                }, 1000)
              } else {
                const config2 = {
                  method: 'get',
                  url: 'https://empresa-service.intrare.app/bitacora/' + id,
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.language,
                  },
                };
                axios(config2)
                    .then(ok => {
                      this.dataAccessNoCode = ok.data[0]
                      console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
                      console.log(this.dataAccessNoCode)
                      console.log('Id = ', this.dataAccessNoCode.id)
                    })
                    .catch(error => {
                      console.log(error)
                    })
              }
            },
            countDownSignTimer() {
                if(this.countDownSign > 0) {
                    setTimeout(() => {
                        this.countDownSign -= 1
                        this.countDownSignTimer()
                    }, 1000)
                }
            },
            getRecordAccessNoCodeById(id) {
              this.loadingCountInAccessNoCode = true
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/bitacora/' + id,
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language,
                },
              };
              axios(config)
                  .then(ok => {
                    this.loadingCountInAccessNoCode = false
                    this.dataAccessNoCode = ok.data[0]
                    if (this.dataAccessNoCode.estado === 0 || this.dataAccessNoCode.estado === 5) {
                      this.entrada = true
                      this.salida = false
                    } else {
                      this.entrada = false
                      this.salida = true
                    }
                  })
                  .catch(error => {
                    this.loadingCountInAccessNoCode = false
                    console.log(error)
                  })
            },
            getRecordAccessNoCodeByIdLoading(id) {
              this.loadingCountInAccessNoCode = true
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/bitacora/' + id,
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language,
                },
              };
              axios(config)
                  .then(ok => {
                    this.loadingCountInAccessNoCode = false
                    this.dataAccessNoCode = ok.data[0]
                    if (this.dataAccessNoCode.estado === 0 || this.dataAccessNoCode.estado === 5) {
                      this.entrada = true
                      this.salida = false
                    } else {
                      this.entrada = false
                      this.salida = true
                    }
                    this.data_accesos_without_code = this.dataAccessNoCode
                    this.dialog_accesos_without_code = true
                    console.log(this.data_accesos_without_code)
                  })
                  .catch(error => {
                    this.loadingCountInAccessNoCode = false
                    console.log(error)
                  })
            },
            notificar_anfitrion_acceso_sin_codigo(id){
              this.loading = true
              console.log('Avisar al Anfitrión que autorize el acceso sin codigo dela persona = ', id)
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + id + '/',
                headers: {
                  'Content-Type': 'application/json',
                }
              };
              axios(config)
                  .then(response => {
                    this.loading = false
                    this.countDownAuthorizedAccessNoCode = 30
                    this.countDownTimerAccessNoCode(id)
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'success')
                    this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                    setTimeout(this.clear3, 3000)
                  })
                  .catch(error => {
                    this.loading = false
                    console.log(error)
                  })
            },
            countDownTimer() {
                if(this.countDownAuthorized > 0) {
                    setTimeout(() => {
                        this.countDownAuthorized -= 1
                        this.countDownTimer()
                    }, 1000)
                }
            },
            countDownPassTimer() {
                if(this.countDownPass > 0) {
                    setTimeout(() => {
                        this.countDownPass -= 1
                        this.countDownPassTimer()
                    }, 1000)
                }
            },
            notificar_anfitrion_acceso(){
                this.loading = true
                console.log('Avisar al Anfitrión que autorize el acceso sin codigo dela persona = ', this.idAccessNoCode)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + this.idAccessNoCode + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDownAuthorized = 30
                        this.countDownTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_firmar(id){
                this.loading = true
                console.log('Avisar al Anfitrión que firme el pase de salida del acceso sin codigo = ', id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifySignExitPassAccessNoCode/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDownSign = 30
                        this.countDownSignTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                          method: 'get',
                          url: 'https://empresa-service.intrare.app/bitacora/' + id,
                          headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language,
                          },
                        };
                        axios(config2)
                            .then(ok => {
                              this.dataAccessNoCode = ok.data[0]
                              console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
                              console.log(this.dataAccessNoCode)
                              console.log('Id = ', this.dataAccessNoCode.id)
                            })
                            .catch(error => {
                              console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            create_check_out_access_no_code (id) {
                this.loading = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/registrar_salida/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      id_guardhouse_checkout: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.errores_guard =this.$t('mensaje_alta_acceso_out')
                        this.head_color = 'green display-1 text--primary'
                        this.dialog_errores = true
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            create_access_no_code (id) {
                this.loading = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/update_access_no_code/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data:{
                      id_guardhouse_checkin: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.head_color = 'green display-1 text--primary'
                        this.band_gafete = true
                        this.dialog_errores = true
                        this.getRecordAccessNoCodeById(id)
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            xOffset: function(pdf, text){
                console.log('Page width =', pdf.internal.pageSize.width)
                console.log('text width =', pdf.getStringUnitWidth(text))
                console.log('Font width =', pdf.internal.getFontSize())
                return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
            },
            download_gafete (fullname_guest, fullname_host, date, company_logo){
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };
                var pdf = new jsPDF('l', 'in', [288, 144])
                // Black square with rounded corners
                pdf.setDrawColor(0)
                pdf.setFontSize(9)
                pdf.text(this.$t('fecha_hora_acceso'),
                    2.3,
                    0.4)
                pdf.setLineWidth(0.02)
                pdf.line(2.3, 0.42, 3.7, 0.42)
                pdf.setFontStyle("normal")
                pdf.text(date,
                    2.7,
                    0.6)
                pdf.setFontSize(14)
                pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.6, 0.92)
                pdf.setFontStyle("bold")
                pdf.text(this.$t('Visitante').toUpperCase(),
                    this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
                    0.9)
                pdf.setFontSize(16)
                pdf.setFontStyle("normal")
                pdf.text(fullname_guest,
                    this.xOffset(pdf, fullname_guest),
                    1.2)
                pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.6, 1.47)
                pdf.setFontSize(14)
                pdf.setFontStyle("bold")
                pdf.text(this.$t('Anfitrion').toUpperCase(),
                    this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
                    1.45)
                pdf.setFontSize(16)
                pdf.setFontStyle("normal")
                pdf.text(fullname_host,
                    this.xOffset(pdf, fullname_host),
                    1.70)
                pdf.setTextColor('#000000')
                toDataUrl(company_logo, (logo_guest) => {
                    pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.9, 0.7)
                    pdf.save('gafete.pdf')
                })
                // pdf.save('gafete.pdf')
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            estadoFormat(value){
                if (value === 0)
                    return  this.$t('pending_authorization')
                if (value === 1)
                    return  this.$t('adentro')
                if (value === 2)
                    return  this.$t('completado')
                if (value === 3)
                    return  this.$t('no_firmado') + '/' + this.$t('completado')
                if (value === 4)
                    return  this.$t('deny')
                if (value === 5)
                    return  this.$t('waiting_room')
            },
            typeAccessFormat(value) {
              if (value === true)
                return  this.$t('acceso_con_codigo')
              return  this.$t('acceso_sin_codigo')
            },
            get_current_date_menu: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            get_detail: function (id_invitacion) {
                this.$router.push('/detalle-invitacion/' + id_invitacion)
            },
            fetch_invitation_details_for_modal: function(item) {
                this.selected_invitation = item
                this.dialog_invitation_details = true
                this.loading_invitation_details = true
                
                // Check if it's a parking reservation (new API)
                if (item.isParkingReservation) {
                    this.info_invitation = item
                    this.loading_invitation_details = false
                }
                // Old invitation flow with QR code
                else if (item.qr_code && item.qr_code.length > 5) {
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/Parking/invitations/guard/qr/' + item.qr_code + '/',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            this.info_invitation = response.data
                            this.loading_invitation_details = false
                        })
                        .catch(error => {
                            console.error("No se pudo obtener información del endpoint QR.", error)
                            this.info_invitation = {}
                            this.loading_invitation_details = false
                            // Fallback to minimal data if needed, or display "no data" placeholder
                        })
                } else {
                    this.info_invitation = {}
                    this.loading_invitation_details = false
                    console.log("No qr_code available to fetch details")
                }
            },
            cancelar_invitacion: function () {
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/Invitation/cancelar/' + this.id_invitacion_eliminar + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken,
                        'Accept-Language': this.language,
                    }
                };
                axios(config)
                    .then(response => {
                        this.dialog_elimnar = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('msg_cancelado_exitoso'))
                        this.get_parking_reservations_sent(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'error')
                        if(error.response.status === 400){
                            this.$store.commit('snackbar_change_message', this.$t('invitacion_previamente_cancelada'))
                        }else{
                            this.$store.commit('snackbar_change_message', this.$t('error_al_cancelar_invitacion'))
                        }
                        console.log(error)
                    })
            },
            get_parking_invitations_sent: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_parking_sent = true
                let url = 'https://empresa-service.intrare.app/Parking/invitations/sent/';
                if (yyyy && mm && dd && yyyy2 && mm2 && dd2) {
                    url += `?date_from=${yyyy}-${mm}-${dd}&date_to=${yyyy2}-${mm2}-${dd2}`;
                }
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.parking_invitations_sent = {invitations: [], pending_referred: []};
                        else
                            this.parking_invitations_sent = response.data;
                        this.loading_parking_sent = false;
                    })
                    .catch(error => {
                        this.loading_parking_sent = false
                        console.log(error)
                    })
            },
            get_parking_reservations_sent: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_parking_reservations_sent = true
                let url = 'https://empresa-service.intrare.app/Parking/invitations/reservations/list/';
                if (yyyy && mm && dd && yyyy2 && mm2 && dd2) {
                    url += `?role=owner&date_from=${yyyy}-${mm}-${dd}&date_to=${yyyy2}-${mm2}-${dd2}`;
                } else {
                    url += '?role=owner';
                }
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.parking_reservations_sent = [];
                        else
                            this.parking_reservations_sent = Array.isArray(response.data) ? response.data : [];
                        this.loading_parking_reservations_sent = false;
                    })
                    .catch(error => {
                        this.loading_parking_reservations_sent = false
                        console.log(error)
                    })
            },
            get_current_date_menu2: function (){
                var today = new Date();
                today.setDate(today.getDate() + 7)
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            get_current_date: function (){
                var today = new Date();
                this.dd = today.getDate();
                this.mm = today.getMonth()+1;
                this.yyyy = today.getFullYear();
                this.dd2 = today.getDate();
                this.mm2 = today.getMonth()+1;
                this.yyyy2 = today.getFullYear();

                if(this.dd<10)
                {
                    this.dd='0'+this.dd;
                }
                if(this.dd2<10)
                {
                    this.dd2='0'+this.dd2;
                }

                if(this.mm<10)
                {
                    this.mm='0'+this.mm;
                }
                if(this.mm2<10)
                {
                    this.mm2='0'+this.mm2;
                }

                today = this.yyyy + '-' + this.mm + '-' + this.dd;
                return today
            },
            formatDateDDMMYYYY: function (inputDate) {
                if (!inputDate) return '';
                const datePart = inputDate.split('T')[0].split(' ')[0]; // elimina la hora
                const parts = datePart.split('-');
                if (parts.length === 3) {
                    return `${parts[0]}/${parts[1]}/${parts[2]}`;
                }
                return inputDate;
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            split_date: function(date, date2){
                var arr = date.split('-')
                var arr2 = date2.split('-')

                this.yyyy = arr[0]
                this.mm = arr[1]
                this.dd = arr[2 ]

                this.yyyy2 = arr2[0]
                this.mm2 = arr2[1]
                this.dd2 = arr2[2 ]
            },
            get_access_without_code_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_without_code = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_bitacoraByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/'+ yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.status === 204)
                            this.accesos_without_code = []
                        else
                            this.accesos_without_code = response.data
                        this.loading_data_accesos_without_code = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_without_code = false
                        console.log(error)
                    })

            },
            get_access_no_code_express_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_no_code_express = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_bitacora_expressByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/'+ yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.status === 204)
                            this.accesos_no_code_express = []
                        else
                            this.accesos_no_code_express = response.data
                        this.loading_data_accesos_no_code_express = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_no_code_express = false
                        console.log(error)
                    })

            },
            get_access_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getAccessByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.status === 204)
                            this.accesos = []
                        else
                            this.accesos = response.data
                        this.loading_data_accesos = false
                    })
                    .catch(error => {
                        this.loading_data_accesos = false
                        console.log(error)
                    })

            },
            fill_fields: function(item){
                this.getRecordAccessNoCodeByIdLoading(item.id)
            },
            fill_fields_express: function(item){
                this.data_accesos_no_code_express = item
                console.log(this.data_accesos_no_code_express)
            },
            firmar: function(pk){
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/firmar_salida/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_access_without_code_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            firmar_express: function(pk){
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/firmar_salida_express/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_access_no_code_express_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            exportPdfAccess () {
                var adentro = this.$t('adentro')
                var completado = this.$t('completado')
                var denegado = this.$t('deny')
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerAccessExcel = this.$t('headerAccessExcel')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos.length.toString()
                var columns = [{
                    guestFName: this.$t('Visitante'),
                    guestLName: this.$t('Apellido'),
                    companyName: this.$t('Empresa'),
                    temperature: this.$t('temperature'),
                    estado: this.$t('estado'),
                    fecha_hora_acceso: this.$t('hora_acceso'),
                    fecha_hora_salida: this.$t('hora_salida'),
                    hostFirstName: this.$t('Anfitrion'),
                    hostLastName: this.$t('Apellido'),
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.accesos,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessExcel, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        // var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        // if (typeof doc.putTotalPages === 'function') {
                        //     str = str + de + totalPagesExp
                        // }
                        // doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        // var pageSize = doc.internal.pageSize
                        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.row.section === 'body') {
                            if (data.column.index === 4) {
                                if (data.cell.text.toString() === '1') {
                                    data.cell.text = adentro
                                } else
                                if (data.cell.text.toString() === '2') {
                                    data.cell.text = denegado
                                } else {
                                    data.cell.text = completado
                                }
                            }
                        }
                    },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.addPage()
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerAccessNoCode = this.$t('accesos_sin_codigo')
                var pendiente = this.$t('pendiente')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos_without_code.length.toString()
                var columns = [{
                    nombre: this.$t('Visitante'),
                    empresa: this.$t('Empresa'),
                    f_acceso: this.$t('hora_acceso'),
                    f_salida: this.$t('hora_salida'),
                    hostFirstName: this.$t('Anfitrion'),
                }]

                doc.autoTable({
                    head: columns,
                    body: this.accesos_without_code,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        // var str = page + doc.internal.getNumberOfPages()
                        // // Total page number plugin only available in jspdf v1.0+
                        // if (typeof doc.putTotalPages === 'function') {
                        //     str = str + de + totalPagesExp
                        // }
                        // doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        // var pageSize = doc.internal.pageSize
                        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.column.index === 3) {
                            if(data.cell.text.toString() === ''){
                                data.cell.text = pendiente
                            }
                        }
                    },
                    margin: { top: 90 }
                })
                doc.save('access' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            exportPdfExpressAccess () {
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'

                var headerAccessNoCode = this.$t('historial_accesos_sin_codigo')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos_no_code_express.length.toString()
                var columns = [{
                    nombre: this.$t('Visitante'),
                    areaName: this.$t('Area'),
                    f_acceso: this.$t('hora_acceso'),
                    f_salida: this.$t('hora_salida'),
                    notas: this.$t('Notas'),
                }]

                doc.autoTable({
                    head: columns,
                    body: this.accesos_no_code_express,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        // var str = page + doc.internal.getNumberOfPages()
                        // // Total page number plugin only available in jspdf v1.0+
                        // if (typeof doc.putTotalPages === 'function') {
                        //     str = str + de + totalPagesExp
                        // }
                        // doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        // var pageSize = doc.internal.pageSize
                        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    // didParseCell: function (data) {
                    //     if (data.column.index === 3) {
                    //         if(data.cell.text.toString() === ''){
                    //             data.cell.text = pendiente
                    //         }
                    //     }
                    // },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('accessNocode' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            submit: function(){
                this.split_date(this.date, this.date2)
                this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_access_parking_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_parking_reservations_sent(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_access_no_code_express_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            },
            get_access_union_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_access2 = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getAccessByDateRangeUnion/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                          this.access = response.data
                        this.loading_data_access2 = false
                    })
                    .catch(error => {
                        this.loading_data_access2 = false
                        console.log(error)
                    })

            },
            addAccessCarrierData () {
              this.loading = true
              let URL_ACCESS = 'https://empresa-service.intrare.app/empresas/access/update/transport_data/' + this.idAccess + '/'
              let URL_ACCESS_NO_CODE = 'https://empresa-service.intrare.app/bitacora/update/transport_data/' + this.idAccess + '/'
              let URL_ACCESS_CONTRACTOR = 'https://empresa-service.intrare.app/access_contractor/update/transport_data/' + this.idAccess + '/'
              let URL_FINAL = ''
              if(this.accessQRCode === false) {
                URL_FINAL = URL_ACCESS_NO_CODE
              } else {
                if (this.accessContractor === true) {
                    URL_FINAL = URL_ACCESS_CONTRACTOR
                } else {
                    URL_FINAL = URL_ACCESS
                }
              }
              // console.log('Tipo de Servicio = ', this.typeService)
              if (this.typeService !== null && this.case_plates === null && this.container_platform_plates === null && this.transport_line === null && this.supplier_customer_name === null)
              {
                  this.bandConfirm = true
                  this.loading = false
              } else
                if (this.typeService === null) {
                  this.loading = false
                } else {
                  const config = {
                    method: 'patch',
                    url: URL_FINAL,
                    headers: {
                      'Content-Type': 'application/json',
                      'Accept-Language': this.language,
                      'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      download: this.typeService,
                      case_plates: this.case_plates,
                      container_platform_plates: this.container_platform_plates,
                      transport_line: this.transport_line,
                      supplier_customer_name: this.supplier_customer_name
                    }
                  };
                  axios(config)
                      .then(response => {
                        this.loading = false
                        this.dialogTransport = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('data_added_successfully'))
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        setTimeout(this.clear, 3000)
                      })
                      .catch(error => {
                        this.loading = false
                        console.log(error)
                      })
                }
            },
            altaPlacas () {
                this.loading = true
                this.errores = []
                var bodyFormData = new FormData()
                var fileImage = null
                const newID = this.$uuid.v4()

                if (this.img !== '' && this.img.length > 6) {
                    fileImage = this.dataURLtoFile(this.img, 'picture' + newID + '.png')
                }
                bodyFormData.append('placas', fileImage)
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/placas/' + this.idAccess + '/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'authorization': 'Token ' + store.getters.getToken,
                        'Accept-Language': this.language,
                    },
                    data: bodyFormData
                };
                axios(config)
                    .then(ok => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('placas_alta'))
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
                    .finally(() => (this.loading = false, this.dialogPlacas =false))

            },
            clear () {
                this.alerta = false
                this.errores = []
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
                this.img = ''
            },
            openAccessDetails(accessItem) {
                this.dialog_access_details = true
                this.loading_access_details = true
                this.access_details_data = {}
                
                // Hacer fetch al endpoint history para obtener más detalles
                const config = {
                    method: 'get',
                    url: `https://empresa-service.intrare.app/Parking/invitations/history/?qr_code=${accessItem.qr_code}`,
                    headers: {
                        'authorization': 'Token ' + store.getters.getToken,
                        'Accept-Language': this.language,
                    }
                }
                
                axios(config)
                    .then(response => {
                        // Combinar datos del item original con los del endpoint history
                        const historyData = response.data.history && response.data.history.length > 0 ? response.data.history[0] : {}
                        
                        this.access_details_data = {
                            ...accessItem,
                            // Enriquecer con datos del proveedor desde history
                            provider_first_name: historyData.provider_first_name || accessItem.provider_first_name || '',
                            provider_last_name: historyData.provider_last_name || accessItem.provider_last_name || '',
                            provider_phone: historyData.provider_phone || accessItem.provider_phone || '',
                            provider_email: historyData.provider_email || accessItem.provider_email || '',
                            provider_ine: historyData.provider_ine || accessItem.provider_ine || '',
                            provider_plates: historyData.provider_plates || accessItem.provider_plates || '',
                            provider_unit_specs: historyData.provider_unit_specs || accessItem.provider_unit_specs || ''
                        }
                        this.loading_access_details = false
                    })
                    .catch(error => {
                        console.log('Error fetching access details:', error)
                        // Si hay error, usar solo los datos del item
                        this.access_details_data = accessItem
                        this.loading_access_details = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_change_message', 'Error al cargar los detalles')
                    })
            },
            /**
             * Exportar detalles de accesos a parqueadero a PDF
             */
            exportPdfAccessParking() {
                if (!this.dataAccessParking || this.dataAccessParking.length === 0) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'No hay datos para exportar')
                    return
                }

                const fechaInicial = this.formatDate(this.date)
                const fechaFinal = this.formatDate(this.date2)
                const title = this.$t('access_history_parking') || 'Historial de Accesos a Parqueadero'
                const period = this.$t('period') || 'Período'
                const al = this.$t('al') || 'al'
                const page = this.$t('page') || 'Página'
                const de = this.$t('de') || 'de'
                
                const columns = [
                    { header: this.$t('Visitante') || 'Visitante', dataKey: 'guest_name' },
                    { header: this.$t('Empresa') || 'Empresa', dataKey: 'company_name' },
                    { header: this.$t('espacios') || 'Espacio', dataKey: 'space_number' },
                    { header: this.$t('tipo_acceso_transportista') || 'Tipo Acceso', dataKey: 'access_type' },
                    { header: this.$t('hora_acceso') || 'Hora Acceso', dataKey: 'access_time' },
                    { header: this.$t('hora_salida') || 'Hora Salida', dataKey: 'exit_time' },
                    { header: this.$t('Vigilante') || 'Registrado por', dataKey: 'registered_by_name' },
                    { header: this.$t('transportista_nombre') || 'Transportista Nombre', dataKey: 'provider_first_name' },
                    { header: this.$t('transportista_apellido') || 'Transportista Apellido', dataKey: 'provider_last_name' },
                    { header: this.$t('telefono_transportista') || 'Teléfono', dataKey: 'provider_phone' },
                    { header: this.$t('placas') || 'Placas', dataKey: 'provider_plates' },
                    { header: this.$t('vehiculo') || 'Vehículo', dataKey: 'provider_unit_specs' },
                ]

                const tableData = this.dataAccessParking.map(item => ({
                    guest_name: item.guest_name || '',
                    company_name: item.guest_company || item.company_name || '',
                    space_number: item.space_number || '',
                    access_type: item.access_type || '',
                    access_time: item.access_time || '',
                    exit_time: item.exit_time || '',
                    registered_by_name: item.registered_by_name || '',
                    provider_first_name: item.provider_first_name || '',
                    provider_last_name: item.provider_last_name || '',
                    provider_phone: item.provider_phone || '',
                    provider_plates: item.provider_plates || '',
                    provider_unit_specs: item.provider_unit_specs || '',
                }))

                const doc = new jsPDF('landscape', 'pt', 'letter')
                const pageHeight = doc.internal.pageSize.height
                const pageWidth = doc.internal.pageSize.width
                const totalPagesExp = '{total_pages_count_string}'
                
                doc.autoTable({
                    head: [columns.map(col => col.header)],
                    body: tableData.map(row => columns.map(col => row[col.dataKey])),
                    didDrawPage: function(data) {
                        // Header
                        doc.setFontSize(18)
                        doc.text(title, pageWidth / 2, 40, { align: 'center' })
                        
                        // Período
                        doc.setFontSize(11)
                        doc.text(
                            `${period}: ${fechaInicial} ${al} ${fechaFinal}`,
                            pageWidth / 2,
                            60,
                            { align: 'center' }
                        )
                        
                        // Footer
                        const str = `${page} ${data.pageCount}`
                        doc.setFontSize(10)
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    margin: { top: 80 },
                    styles: { fontSize: 9, cellPadding: 5 },
                    headStyles: { fillColor: [0, 43, 72], textColor: 255, fontStyle: 'bold' },
                })

                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }

                doc.save(`acceso_parqueadero_${this.date}_${this.date2}.pdf`)
                
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_change_message', 'PDF exportado correctamente')
            },
            /**
             * Exportar detalles de accesos a parqueadero a Excel (CSV)
             */
            exportExcelAccessParking() {
                if (!this.dataAccessParking || this.dataAccessParking.length === 0) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', 'No hay datos para exportar')
                    return
                }

                // Headers
                const headers = [
                    this.$t('Visitante') || 'Visitante',
                    this.$t('Empresa') || 'Empresa/Asunto',
                    this.$t('espacios') || 'Espacio',
                    this.$t('tipo_acceso_transportista') || 'Tipo Acceso',
                    this.$t('hora_acceso') || 'Hora Acceso',
                    this.$t('hora_salida') || 'Hora Salida',
                    this.$t('Vigilante') || 'Registrado por',
                    this.$t('transportista_nombre') || 'Transportista Nombre',
                    this.$t('transportista_apellido') || 'Transportista Apellido',
                    this.$t('telefono_transportista') || 'Teléfono',
                    this.$t('placas') || 'Placas',
                    this.$t('vehiculo') || 'Vehículo',
                ]

                // Datos
                const data = this.dataAccessParking.map(item => [
                    item.guest_name || '',
                    item.guest_company || item.company_name || '',
                    item.space_number || '',
                    item.access_type || '',
                    item.access_time || '',
                    item.exit_time || '',
                    item.registered_by_name || '',
                    item.provider_first_name || '',
                    item.provider_last_name || '',
                    item.provider_phone || '',
                    item.provider_plates || '',
                    item.provider_unit_specs || '',
                ])

                // Construir CSV
                let csv = headers.join(',') + '\n'
                data.forEach(row => {
                    csv += row.map(cell => {
                        // Escapar comillas y envolver en comillas si contiene comas
                        const cellStr = String(cell).replace(/"/g, '""')
                        return cellStr.includes(',') ? `"${cellStr}"` : cellStr
                    }).join(',') + '\n'
                })

                // Crear blob y descargar
                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
                const link = document.createElement('a')
                const url = URL.createObjectURL(blob)
                
                link.setAttribute('href', url)
                link.setAttribute('download', `acceso_parqueadero_${this.date}_${this.date2}.csv`)
                link.style.visibility = 'hidden'
                
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_change_message', 'Excel exportado correctamente')
            },
        }
    }
</script>


<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }
</style>
